import React, { useState } from 'react';
import styled from 'styled-components';
import { Modal } from '../../../components';
import LoginForm from './LoginForm';
import ResetPasswordForm from './ResetPasswordForm';

const StyledModal = styled(Modal)`
    width: 500px !important;
`;

function LoginDialog({ trigger, open, onClose }) {
    const [resetPasswordDialog, showResetPasswordForm] = useState(false);

    const handleClose = () => {
        showResetPasswordForm(false);
        onClose();
    };

    return (
        <StyledModal trigger={trigger} open={open} onClose={handleClose} dimmer="blurring">
            {resetPasswordDialog ? (
                <ResetPasswordForm showResetPasswordForm={showResetPasswordForm} />
            ) : (
                <LoginForm showResetPasswordForm={showResetPasswordForm} />
            )}
        </StyledModal>
    );
}

export default LoginDialog;
